import GiveawayHistoryCards from "../../../../Giveaways/HoldGiveaway/components/GiveawayHistoryCards";

export default GiveawayHistoryCards;
